import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { FormattedMessage, injectIntl } from 'react-intl';
import { FONT_FAMILIES, FONT_SIZES, COLOR, SPACE } from 'config';
import { Flex, Box } from 'grid-styled';
import { rem } from 'polished';
import ReactMd from 'react-md-file';
import Sticky from 'react-sticky-el';

import Button from 'components/Button';
import styled from 'styled-components';
import Header from 'components/Header';
import Footer from 'components/Footer';
import TopBanner from 'components/TopBanner';
import Heading from 'components/Heading';
import SignUpSection from 'components/SignUpSectionSecondary';
import Container from 'components/Container';
import CxSideMenu from './components/CxSideMenu';

import home from './content/home.md';
import banner from './CX.svg';
import book from './book-cover.png';

const Wrapper = styled(Box)`
  column-gap: ${props => props.theme.space[7]}px;
  padding-bottom: ${props => props.theme.space[10]}px;
  justify-content: left;
  width: 100%
`;

const Banner = styled(TopBanner)`
  background-color: #101F34;
`;

const Ads = styled.div`
  padding: 30px;
  background-color: ${COLOR.base};
  color: white !important;

  a {
    text-decoration: none !important;
    color: white !important;
    font-size: ${rem(18)};
  }

  span {
    color: white !important;
  }

`;

const Render = styled.div`
  margin-bottom: ${rem(SPACE[5])};
  font-family: ${FONT_FAMILIES.sans};
  color: ${COLOR.textDark};
  font-size: ${rem(FONT_SIZES[2])};
  line-height: ${rem(25)};
  word-break: break-word;

  pre {
    padding: 40px;
    background-color: #F8F8F8;
    word-break: break-all !important;
    white-space: -moz-pre-wrap;
    white-space: pre-wrap;

    code {
      word-break: break-all !important;
      white-space: -moz-pre-wrap;
      white-space: pre-wrap;
    }
  }

  a {
    text-decoration: none !important;
    color: ${COLOR.base};
  }
`;

const Text = styled.p`
  padding-bottom: ${rem(SPACE[6])};
`;

const Book = styled.img`
  padding-right: 30px;
  padding-left: 30px;
  height: 100%;
  width: auto;

  @media (max-width: 1117px) {
    display: none;
  }
`;

const StyledButton = styled(Button)`
  color: ${COLOR.white} !important;
  background-color:${COLOR.base};

  &:hover{
    background-color:${COLOR.base};
    color:${COLOR.white};
  }
`;

const CXs = ({ intl }) => (
  <div>
    <Helmet>
      <title>{intl.formatMessage({ id: 'cx.title' })}</title>
      <meta
        name="description"
        content={intl.formatMessage({ id: 'cx.description' })}
      />
    </Helmet>
    <Header />
    <Banner src={banner} />
    <Container>
      <Render>
        <Flex wrap>
          <Box width={[1, 1, 1 / 4]} px={2}>
            <Sticky>
              <CxSideMenu />
            </Sticky>
          </Box>
          <Box width={[1, 1, 3 / 4]} px={2} pb={10}>
            <Wrapper pb={[7, 8]}>
              <Flex wrap>
                <Box width={[1, 1, 4 / 6]}>
                  <Heading heavy as="p" fontSize={[3, 4]} width={[1, 1]} color={COLOR.textDark}>
                    <FormattedMessage id="cxs.cx.header.title" />
                  </Heading>
                  <Text>
                    <FormattedMessage id="cxs.cx.header.desc" />
                  </Text>
                </Box>
                <Box width={[1, 1, 2 / 6]}>
                  <StyledButton to="/cx/installation" width="90%" color="white" bg="base" pill ml={[7, 0, 0]} mr={[7, 7, 0]}>
                    <FormattedMessage id="cxs.cx.button" />
                  </StyledButton>
                </Box>
              </Flex>
            </Wrapper>
            <Wrapper pb={[7, 8]}>
              <Ads>
                <Flex wrap>
                  <Box width={[1, 1, 4 / 6]}>
                    <Heading heavy as="p" fontSize={[4, 5]} width={[1, 1]} >
                      <FormattedMessage id="cxs.cx.hero.title" />
                    </Heading>
                    <Text>
                      <FormattedMessage id="cxs.cx.hero.desc" />
                    </Text>
                    <a href="https://github.com/skycoin/cx-book/releases/download/0.5/CX_Programming_Language.pdf" download>
                      <FormattedMessage id="cxs.cx.hero.link" />
                    </a>
                  </Box>
                  <Box width={[1, 1, 2 / 6]}>
                    <Book src={book} />
                  </Box>
                </Flex>
              </Ads>
            </Wrapper>
            <div>
              <ReactMd fileName={home} />
            </div>
          </Box>
        </Flex>
      </Render>
    </Container>
    <SignUpSection />
    <Footer />
  </div>
);

CXs.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};

CXs.defaultProps = {
  heading: '',
};

export default injectIntl(CXs);



// WEBPACK FOOTER //
// ./src/components/CXs/CXs.js